import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { KeywordsService } from "./keywords.service";

@Injectable({
    providedIn: 'root'
})

export class LiveDealerService {

    public customer: CustomerModel;

    private favouriteKeywordsSource = new BehaviorSubject<any[]>([]);
    public favouriteKeywords$ = this.favouriteKeywordsSource.asObservable();
    public favouriteGameData: any;

    constructor(
        private readonly keywordsService: KeywordsService,
        private readonly webservicesService: WebservicesService,
        private readonly userSessionService: UserSessionService,
    ) {
        this.userSessionService.getCustomerSubscription().then((customerSubscription) => {
            customerSubscription.subscribe((customer) => this.customer = customer);
            this.refreshFavouriteKeywords();
        });
    }

    addFavouriteKeyword(game_id): Observable<any> {
        if (!this.customer) {
            return throwError("No customer available.");
        }

        const lobby = this.keywordsService.getLobbyList()[0]?.name;
        const obj = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.getSessionToken(),
            keyword_id: game_id,
            lobby_name: lobby
        }
        return this.webservicesService.post("lobby/add-favorite-keyword", obj).pipe(
            catchError(error => {
                console.error("Error adding Fav Games", error);
                return throwError(error);
            }),
            tap(() => this.refreshFavouriteKeywords())
        );
    }

    removeFavouriteKeyword(game_id): Observable<any> {
        if (!this.customer) {
            return throwError("No customer available.");
        }

        const lobby = this.keywordsService.getLobbyList()[0]?.name;
        const obj = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.getSessionToken(),
            keyword_id: game_id,
            lobby_name: lobby
        }
        return this.webservicesService.post("lobby/remove-favorite-keyword", obj).pipe(
            catchError(error => {
                console.error("Error Removing Fav Games", error);
                return throwError(error);
            }),
            tap(() => this.refreshFavouriteKeywords())
        );
    }

    async checkFavouriteKeyword(): Promise<any> {
        try {
            const response = await this.favouriteKeywordCheck().toPromise();

            if (response.result) {
                return response;
            } else {
                console.error("Error Getting fav Keywords", response);
            }
        } catch (error) {
            console.error("Error Getting fav Keywords");
        }
    }

    favouriteKeywordCheck(): Observable<any> {
        if (!this.customer) {
            return throwError("No customer available.");
        }

        const lobby = this.keywordsService.getLobbyList()[0]?.name;
        const obj = {
            customer_id: this.customer.customerId,
            session_token: this.userSessionService.getSessionToken(),
            lobby_name: lobby
        }
        return this.webservicesService.get("lobby/get-favorite-keywords", obj).pipe(
            catchError(error => {
                console.error("Error Getting fav Keywords", error);
                return throwError(error);
            })
        );
    }

    private refreshFavouriteKeywords() {
        this.favouriteKeywordCheck().subscribe(
            response => {
                if (response.result) {
                    this.favouriteKeywordsSource.next(response.payload || []);
                }
            },
            error => console.error("Error refreshing fav Keywords", error)
        );
    }

    public setLDFavouriteGameData(data){
        this.favouriteGameData = data;
    }

    public getLDFavouriteGameData(){
        return this.favouriteGameData;
    }

}